import type { RouteObject } from "react-router-dom";
import { MarketingMicroSite } from "./pages/marketing-microsite/marketing-microsite.page";

export const appRoutes: RouteObject[] = [
  {
    path: "*",
    element: <MarketingMicroSite />,
  },
];
